import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  GuardResult,
  MaybeAsync,
  RouterStateSnapshot,
} from '@angular/router';
import { marker as _ } from '@jsverse/transloco-keys-manager/marker';
import { first, of, Subject } from 'rxjs';
import { IDirtyCheckComponent } from '../models/dirty-check.model';
import { ConfirmationService } from '../services/confirmation.service';

@Injectable({ providedIn: 'root' })
export class ComponentDirtyCheckGuard implements CanDeactivate<IDirtyCheckComponent> {
  private readonly confirmationService = inject(ConfirmationService);

  canDeactivate(
    component: IDirtyCheckComponent,
    _currentRoute: ActivatedRouteSnapshot,
    _currentState: RouterStateSnapshot,
    _nextState: RouterStateSnapshot,
  ): MaybeAsync<GuardResult> {
    if (!component.isDirty) {
      return of(true);
    }

    const canDeactivateSubject = new Subject<boolean>();
    this.confirmationService
      .confirm({
        header: _('i18n.Common.Confirm.DirtyCheck.Header'),
        message: _('i18n.Common.Confirm.DirtyCheck.Label'),
        acceptLabel: _('i18n.Common.Confirm.DirtyCheck.Accept'),
      })
      .pipe(first())
      .subscribe((result) => canDeactivateSubject.next(result.accepted));

    return canDeactivateSubject;
  }
}
